<template>
  <div>
    <!-- Filters -->
    <InvoicesListFilters></InvoicesListFilters>


    <!-- Table Container Card -->
    <BCard no-body>
      <div class="m-2">
        <!-- Table Top -->
        <BRow>

          <!-- Per Page -->
          <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
            <label>{{$t("Entries")}}</label>
            <vSelect v-model="perPage"  :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block ml-50 mr-1" />
          </BCol>

          <!-- Search -->
          <BCol cols="12"  md="8" lg="7" xl="6">
            <div class="d-flex align-items-center justify-content-between">
              <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
              <BDropdown v-if="user.role=='Superadministrador'" variant="success" right class="mr-1">
                <template #button-content>
                  <FeatherIcon icon="FileTextIcon" class="mr-50" />
                  <span class="text-nowrap">Exportar</span>
                </template>
                <BDropdownItem @click="exportBilling">
                    <FeatherIcon icon="FileIcon" />
                    <span class="align-middle ml-50">Facturación</span>
                </BDropdownItem>
                <BDropdownItem @click="exportInvoices('all','XLS', true)">
                    <FeatherIcon icon="FileIcon" />
                    <span class="align-middle ml-50">Facturas XLS</span>
                </BDropdownItem>
                <BDropdownItem @click="exportAllChargesXLS">
                    <FeatherIcon icon="FileIcon" />
                    <span class="align-middle ml-50">Cobros XLS</span>
                </BDropdownItem>
                <BDropdownItem @click="exportInvoices('all','CSV', true)">
                    <FeatherIcon icon="FileIcon" />
                    <span class="align-middle ml-50">Facturas CSV</span>
                </BDropdownItem>
                <BDropdownItem @click="exportAllChargesCSV">
                    <FeatherIcon icon="FileIcon" />
                    <span class="align-middle ml-50">Cobros CSV</span>
                </BDropdownItem>
              </BDropdown>
              <BButton v-if="ability.can('create', 'invoice')" variant="primary"  :to="{ name: 'invoices-add'}"> <span class="text-nowrap">{{$t("Add invoice")}}</span> </BButton>

            </div>

          </BCol>
        </BRow>

      </div>

      <BTable ref="refInvoiceListTable" :items="fetchInvoices" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found" :sort-desc.sync="isSortDirDesc" class="position-relative">

        <!-- Column: Amount -->
        <template #cell(amount)="data">
            <p class="text-center m-0"><b>{{ formatCurrency(data.item.amount) }}</b></p>
            <div class="text-center">
                <BBadge  pill variant="light-warning" v-if="isPartialPaid(data.item.specific_status).value">{{ (isPartialPaid(data.item.specific_status).owe).toFixed(2) }}€ pendientes</BBadge>
            </div>
        </template>

        <!-- Column: Id -->
        <template #cell(id)="data">
          <BLink :to="{ name: 'invoices-view', params: { id: data.item.id }}" class="font-weight-bold">
            <span class="text-nowrap">{{ data.item.name }}</span>
            
          </BLink>
        </template>
        
        <!-- Column: Client -->
        <template #cell(customer_billing_full_name)="data">
          <BMedia vertical-align="center">
            <template #aside>
              <BAvatar size="32" :src="data.item.avatar" :text="avatarText(data.item.customer_billing_full_name)" :variant="`light-${resolveClientAvatarVariant(data.item.invoiceStatus)}`"/>
            </template>
            <BLink v-if="data.item.account_id" :to="{ name: 'accounts-view', params: { id: data.item.account_id } }"  class="font-weight-bold d-block text-nowrap"> {{ data.item.account ? data.item.customer_billing_full_name : ''}}</BLink>
            <BLink v-else-if="data.item.student_id" :to="{ name: 'students-view', params: { id: data.item.student_id } }"  class="font-weight-bold d-block text-nowrap"> {{ data.item.student ? data.item.student.full_name : ''}} </BLink>
            <span v-else class="font-weight-bold d-block text-nowrap text-primary"> {{ data.item.customer_billing_full_name }} </span>
            <!-- <small class="text-muted">{{ data.item.student.email }}</small> -->
            <BLink v-if="data.item.student_id && data.item.account_id" :to="{ name: 'students-view', params: { id: data.item.student_id } }"  class="font-weight-bold d-block text-nowrap"> <small class="text-secondary">{{ data.item.student ? data.item.student.full_name : '' }}</small> </BLink>
            <span v-else  class="font-weight-bold d-block text-nowrap"> {{ data.item.customer_billing_full_name }} </span>

          </BMedia>
        </template>
        
        <!-- Column: Issued Date -->
        <template #cell(dates)="data">
            <small>
              <span class="text-nowrap"><b>Emisión: </b>{{ format(new Date (data.item.emit_date), 'dd-MM-yyyy') }}</span><br>
              <span class="text-nowrap"><b>Vencimiento: </b>{{ data.item.payment_date ? format(new Date (data.item.payment_date), 'dd-MM-yyyy') : '(No definida)' }}</span>
            </small>
        </template>

          <!-- Column: Invoice Status -->
          <template #cell(paid)="data">
          <div>
            <BAvatar :id="`invoice-row-${data.item.id}`" size="32" :variant="`light-${resolveInvoiceStatusVariantAndIcon(data.item.specific_status).variant}`" >
              <FeatherIcon :icon="resolveInvoiceStatusVariantAndIcon(data.item.specific_status).icon" />
            </BAvatar>
            <br>
            <span>{{ resolveInvoiceStatusVariantAndIcon(data.item.specific_status).label }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- Dropdown -->
            <BDropdown variant="link" toggle-class="p-0" no-caret :right="$store.state.appConfig.isRTL" >

              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <!-- Opciones de factura -->
              <div v-if="data.item.n_invoice">
                  <BDropdownItem @click="downloadInvoice( data.item,  String(data.item.n_invoice).padStart(4, '0') )">
                    <feather-icon icon="DownloadIcon" />
                    <span class="align-middle ml-50">{{ $t('Download') }}</span>
                  </BDropdownItem>

                  <BDropdownItem v-if="!data.item.corrective" :to="{ name: 'correct-invoice', params: { id: data.item.id } }">
                        <FeatherIcon icon="MailIcon" />
                        <span class="align-middle ml-50">Rectificar factura</span>
                    </BDropdownItem>

                  <BDropdownItem @click="sendInvoiceEmail(data.item.id, String(data.item.n_invoice).padStart(4, '0') )">
                    <feather-icon icon="MailIcon" />
                    <span class="align-middle ml-50">Enviar correo electrónico</span>
                  </BDropdownItem>
              </div>
              <!-- Opciones de ticket -->
                <div v-if="data.item.n_receipt">
                    <BDropdownItem @click="downloadReceipt( data.item,  String(data.item.n_receipt).padStart(4, '0') )">
                        <feather-icon icon="DownloadIcon" />
                        <span class="align-middle ml-50">{{ $t('Download') }}</span>
                    </BDropdownItem>

                    <BDropdownItem @click="sendInvoiceEmail(data.item.id, String(data.item.n_receipt).padStart(4, '0') )">
                        <feather-icon icon="MailIcon" />
                        <span class="align-middle ml-50">Enviar correo electrónico</span>
                    </BDropdownItem>

                    <BDropdownItem v-if="!data.item.corrective" :to="{ name: 'correct-invoice', params: { id: data.item.id } }">
                        <FeatherIcon icon="MailIcon" />
                        <span class="align-middle ml-50">Rectificar ticket</span>
                    </BDropdownItem>

                    <BDropdownItem v-if="!data.item.corrective" @click="modalOrConvertInvoice(data.item)" >
                        <feather-icon icon="MailIcon" />
                        <span class="align-middle ml-50">Cambiar a factura</span>
                    </BDropdownItem>
                </div>
                <!-- Opciones de ticket rectificativo -->
                <div v-if="data.item.n_corrective_invoice">
                    <BDropdownItem v-if="data.item.n_corrective_invoice" @click="downloadInvoice( data.item,  String(data.item.n_corrective_invoice).padStart(4, '0') )">
                        <feather-icon icon="DownloadIcon" />
                        <span class="align-middle ml-50">{{ $t('Download') }}</span>
                    </BDropdownItem>

                    <BDropdownItem @click="sendInvoiceEmail(data.item.id, String(data.item.n_corrective_invoice).padStart(4, '0') )">
                        <feather-icon icon="MailIcon" />
                        <span class="align-middle ml-50">Enviar correo electrónico</span>
                    </BDropdownItem>
                </div>
                <!-- Opciones de factura rectificativa -->
                <div v-if="data.item.n_corrective_receipt">
                    <BDropdownItem v-if="data.item.n_corrective_receipt" @click="downloadReceipt( data.item,  String(data.item.n_corrective_receipt).padStart(4, '0') )">
                        <feather-icon icon="DownloadIcon" />
                        <span class="align-middle ml-50">{{ $t('Download') }}</span>
                    </BDropdownItem>

                    <BDropdownItem @click="sendInvoiceEmail(data.item.id, String(data.item.n_corrective_receipt).padStart(4, '0') )">
                        <feather-icon icon="MailIcon" />
                        <span class="align-middle ml-50">Enviar correo electrónico</span>
                    </BDropdownItem>
                </div>
                <!-- Opciones generales -->
                <BDropdownItem v-if="isEditable(data.item.is_editable)" :to="{ name: 'invoices-edit', params: { id: data.item.id } }">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">{{ $t('Edit') }}</span>
                </BDropdownItem>
            </BDropdown>
          </div>
        </template>

      </BTable>
      <div class="mx-2 mb-2">
        <BRow>
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
            <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
          </BCol>
          <!-- Pagination -->
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <BPagination v-model="currentPage" :total-rows="totalInvoices" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </BPagination>

          </BCol>

        </BRow>
      </div>
    </BCard>

    <BModal ref="CSV_invoice_modal" centered hide-footer >
            <p>Introduce las fechas: </p>
            <BRow class="mt-2">
                  <DatepickerValidated vsName="Start date" :vsModel.sync="startDateModal" vsRequired vsRules="required"/>
                  <DatepickerValidated vsName="End date" :vsModel.sync="endDateModal" vsRequired vsRules="required" :vsMin="startDateModal"/>
                  <BCol>
                    <BButton @click="exportInvoices(typeInvoiceSelected, typeExportSelected, true)" variant="primary">Exportar</BButton>
                  </BCol>
            </BRow>
    </BModal>

    <BModal  @hidden="hideChangeInvoiceModal" ref="changeInvoiceModal" centered hide-footer title="Elige las series requeridas">
      
      <BRow class="mt-1">
        <!--  :vsOptions="invoice.group.series" -->
          <VSelectValidated v-if="selectedInvoice" :vsDisabled="selectedInvoice.group.invoice_series.length==1" vsName="Serie para crear la nueva factura" :vsReduce="serie=>serie.id" :vsOptions="selectedInvoice.group.invoice_series" :vsModel.sync="selectedInvoiceSerie" vsLabel="search_name" vsRequired vsRules="required"/>
          <VSelectValidated v-if="selectedInvoice" :vsDisabled="selectedInvoice.group.corrective_receipt_series.length==1" vsName="Serie para rectificar el recibo actual" :vsReduce="serie=>serie.id" :vsOptions="selectedInvoice.group.corrective_receipt_series"  :vsModel.sync="selectedCorrectionSerie" vsLabel="search_name" vsRequired vsRules="required"/>
          <BCol>
            <BButton @click="convertIntoInvoice(selectedInvoice.id)" variant="primary">Cambiar</BButton>
          </BCol>
      </BRow>

    </BModal>
  </div>

  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BSpinner} from 'bootstrap-vue'
  import { onUnmounted, provide, ref, watch} from '@vue/composition-api'
  import { avatarText } from '@core/utils/filter'
  import useInvoicesList from './useInvoicesList'
  import invoicesModule from '../invoicesModule'
  import vSelect from 'vue-select'
  import store from '@/store'
  import popups from '@/hooks/popups';
  import InvoicesListFilters from './InvoicesListFilters.vue'
  import paymentMethodModule from '../../payment_methods/paymentMethodModule'
  import axios from '@axios'
  import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
  import { format } from 'date-fns';
  import ability from '@/libs/acl/ability';
  import exportUtils from '@/hooks/exportUtils'
  import currency from '@/utils/currency'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue';

  export default {
    components: { BCard, BSpinner, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, vSelect, InvoicesListFilters, DatepickerValidated, TextInputValidated, VSelectValidated },
    setup() {
        const { fetchInvoices, tableColumns, perPage, currentPage, totalInvoices, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refInvoiceListTable, statusFilter, typeFilter, paymentMethodFilter, groupFilter, startDateFilter, endDateFilter, refetchData, resolveInvoiceStatusVariantAndIcon, resolveClientAvatarVariant } = useInvoicesList()
        const RECEIPT_APP_STORE_MODULE_NAME = 'invoices'
        const PAYMENT_METHOD_MODULE = 'payment_methods'
        const { errorToast, successToast } = popups()
        const user = JSON.parse(localStorage.getItem('userData'))
        const { exportData, openDownloadingAlert, closeDownloadingAlert } = exportUtils()
        const groupsOptions=ref(null)
        const changeInvoiceModal=ref(null)
        const selectedInvoiceSerie=ref(null)
        const selectedCorrectionSerie=ref(null)

        const selectedInvoice=ref(null)
        const { formatCurrency } = currency()
        

        // Modal para descargar CSVs facturas
        const CSV_invoice_modal = ref('')
        const showDates=ref(false)
        const startDateModal=ref(null)
        const endDateModal=ref(null)
        const typeInvoiceSelected=ref(null)
        const typeExportSelected=ref(null)
  
        const exportAllChargesCSV= () => {
          startDateModal.value=null
          endDateModal.value=null
          CSV_invoice_modal.value.show()
          typeInvoiceSelected.value="all-charges"
          typeExportSelected.value="CSV"
        }

        const exportAllChargesXLS= () => {
          startDateModal.value=null
          endDateModal.value=null
          CSV_invoice_modal.value.show()
          typeInvoiceSelected.value="all-charges"
          typeExportSelected.value="XLS"
        }

        // Variables para aplicar os filtros
        const typeOptions = [
          { name: 'Recibo', value: "ticket" },
          { name: 'Ticket rectificativo', value: "r_ticket" },
          { name: 'Factura', value: "invoice" },
          { name: 'Factura rectificativa', value: "r_invoice" }
        ]

        const statusOptions = [
          { name: 'Pagada', value: 1 },
          { name: 'Rectificada', value: -1 },
          { name: 'No pagada', value: 0 },

        ]
        const paymentMethods=ref(null)

        provide('statusOptions', statusOptions)
        provide('typeOptions', typeOptions)
        provide('paymentMethods', paymentMethods)
        provide('groupsOptions', groupsOptions)

        provide('typeFilter', typeFilter)
        provide('statusFilter', statusFilter)
        provide('paymentMethodFilter', paymentMethodFilter)
        provide('groupFilter', groupFilter)
        provide('startDateFilter', startDateFilter)
        provide('endDateFilter', endDateFilter)

        // Métodos

        const setNullDate=() => {
          startDateModal.value=null
          endDateModal.value=null
        }

        /**
         * Enviar factura por correo
         * @param {int} invoiceId
         * @param {int} id
         */
        const sendInvoiceEmail=(invoiceId, id) => {
          store.dispatch('invoices/sendEmail',  {idRC: invoiceId, id: id}).then(response => {

            if (response.data.success) {
              successToast("Correo electrónico enviado")
            } else if (response.data.code=='NO_CLIENT') {
              errorToast("La factura ya no tiene un cliente asociado. Es posible que se haya borrado.")
            } else {
              errorToast("Error enviando correo electrónico")
            }
          }).catch((error)=> {
            errorToast(error)
          })
        }

        /**
         * Descargar la factura en pdf
         * @param {int} invoiceId
         * @param {int} id
         */
        const downloadInvoice=(invoice, id) => {
          store.dispatch('invoices/downloadInvoice',  { idRC: invoice.id, id: id}).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = invoice.name+'.pdf'
                link.click()
                successToast('PDF descargado')
          }).catch((error)=> {
            errorToast(error)
          })
        }

        /**
         * Descargar ticket en pdf
         */
        const downloadReceipt = function(ticket, id){
            store.dispatch('invoices/downloadReceipt',  {idRC: ticket.id, id: id}).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = ticket.name+'.pdf'

                link.click()
                successToast('PDF downloaded')
          })
        }

        const modalOrConvertInvoice = (invoice) => {
          if (invoice.group.invoice_series.length>1 || invoice.group.corrective_receipt_series.length>1 ) {
            invoice.group.invoice_series.length==1 ? selectedInvoiceSerie.value=invoice.group.invoice_series[0].id : '' 
            invoice.group.corrective_receipt_series.length==1 ? selectedCorrectionSerie.value=invoice.group.corrective_receipt_series[0].id : '' 
            showChangeInvoiceModal(invoice)
          } else {
            selectedInvoiceSerie.value=invoice.group.invoice_series[0].id
            selectedCorrectionSerie.value=invoice.group.corrective_receipt_series[0].id
            convertIntoInvoice(invoice.id)
          }
        }

        /**
         * Convertir ticket en factura
         */
        const convertIntoInvoice=(id) => {

          let data = {
            id: id,
            invoice_serie: selectedInvoiceSerie.value,
            correction_serie: selectedCorrectionSerie.value 
          }

          store.dispatch('invoices/convertIntoInvoice', data).then(response => {
              if(response.data.success){
                refetchData()
                successToast("Recibo cambiado a factura correctamente")
                hideChangeInvoiceModal()

              }else{

                if (response.data.msg=="facturation_data_error"){
                  // <span><b-link :to='{ name: 'students-add'}'>aquí</b-link></span>
                  errorToast(`Este cliente no tiene todos los datos de facturación guardados.Por favor, modifíquelo.`)
                } else if (response.data.msg=="settings_data_error") {
                  errorToast(`No puedes crear una factura si no ha añadido los datos de facturación. Por favor, modifíquelo en "Ajustes">"Datos de facturación".`)
                }else {
                  errorToast(response.data.msg)

                }
              }
            })
            .catch(error => {
              errorToast('No se ha podido actualizar la factura.', error)
            })
        }

        /**
         * Mostrar modal de motivos de rectificación factura
         */
        const showChangeInvoiceModal = function (invoice) {
          selectedInvoice.value=invoice
          changeInvoiceModal.value.show()
        }

        const hideChangeInvoiceModal = function () {
          selectedInvoiceSerie.value=null
          selectedInvoice.value=null
          changeInvoiceModal.value.hide()
        }

        /**
         * Comprobación si se puede modificar una factura no siendo superadministrador
         * @param {boolean} is_editable 
         */
        const isEditable = function(is_editable) {
          if(user.role == "Superadministrador") return true
          if(ability.can('write', 'invoice') && ability.can('create', 'invoice')) return true
          if(is_editable && ability.can('create', 'invoice')) return true
          return false
        }

        /**
         * Descargar csv 
         */

        const exportInvoices = function(type, fileType, datesSelected){
          if (datesSelected && (type=="all-charges"  || type=="billing")) {
            if (!startDateModal.value) {
              errorToast("Selecciona una fecha de comienzo.")
              return
            }

            if (!endDateModal.value) {
              errorToast("Selecciona una fecha de fin.")
              return
            }
          }
          CSV_invoice_modal.value.hide()

          if(type == "all"){
           
            let params = {
                  q: searchQuery.value,
                  perPage: perPage.value,
                  page: currentPage.value,
                  sortBy: sortBy.value,
                  sortDesc: isSortDirDesc.value,
                  status: statusFilter.value,
                  type: typeFilter.value,
                  paymentMethod: paymentMethodFilter.value, 
                  group: groupFilter.value,
                  start_date: startDateFilter.value,
                  end_date: endDateFilter.value,
                  file_type: fileType
                }

                let name
                if (startDateFilter.value && endDateFilter.value) {
                   name = `listado_facturas_recibos_${startDateFilter.value}_${endDateFilter.value}`
                } else {
                   name = 'listado_facturas_recibos'
                }

                if(exportData('receiptsinvoices/export', params, name, fileType)) {
                    successToast(`${fileType} descargado`)
                }else{
                    errorToast(`No ha sido posible descargar el ${fileType}`)
                } 
          }

          if(type == "all-charges"){
           
           let params = {
                  start_date: startDateModal.value,
                  end_date: endDateModal.value,
                  status: statusFilter.value,
                  type: typeFilter.value,
                  paymentMethod: paymentMethodFilter.value, 
                  group: groupFilter.value,
                  file_type: fileType
               }
               let name = `listado_cobros_${startDateModal.value}_${endDateModal.value}`
               if(exportData('/receiptsinvoicescharges/export', params, name, fileType)) {
                   startDateModal.value = null
                   endDateModal.value = null
                   successToast(`${fileType} descargado`)
               }else{
                   errorToast(`No ha sido posible descargar el ${fileType}`)
               } 
         }

         if (type == "billing") {
            let params = {
              start_date: startDateModal.value,
              end_date: endDateModal.value
            }
            let name = `facturacion_${startDateModal.value}_${endDateModal.value}`
            if(exportData('/billing/export', params, name, fileType)) {
              startDateModal.value = null
              endDateModal.value = null
              successToast(`${fileType} descargado`)
            }else{
              errorToast(`No ha sido posible descargar el ${fileType}`)
            } 
          }

          

        }

        /**
         * Descargar facturación entre dos fechas
         */

        const exportBilling= () => {
          startDateModal.value=null
          endDateModal.value=null
          CSV_invoice_modal.value.show()
          typeInvoiceSelected.value="billing"
          typeExportSelected.value="XLS"
        }

        // Get groups
        axios.get('groups').then(response=> {
          groupsOptions.value=response.data.groups
        })


        // Register module
        if (!store.hasModule(PAYMENT_METHOD_MODULE)) store.registerModule(PAYMENT_METHOD_MODULE, paymentMethodModule)

        if (!store.hasModule(RECEIPT_APP_STORE_MODULE_NAME))
            store.registerModule(RECEIPT_APP_STORE_MODULE_NAME, invoicesModule)
            store.dispatch('payment_methods/fetchPaymentMethods').then(response => {
              paymentMethods.value = response.data
            })
        

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(RECEIPT_APP_STORE_MODULE_NAME)) store.unregisterModule(RECEIPT_APP_STORE_MODULE_NAME)
            if (store.hasModule(PAYMENT_METHOD_MODULE)) store.unregisterModule(PAYMENT_METHOD_MODULE)
        })



        /**
         * Comprobar si es un pago parcial
         */
        const isPartialPaid = function(statusData){
            if( statusData.status==3) return {value: true , owe: statusData.owe}
            return {value: false}
        }

      return {
        downloadReceipt,
        format,
        isPartialPaid,
        exportInvoices,
        fetchInvoices,
        tableColumns,
        perPage,
        currentPage,
        totalInvoices,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refInvoiceListTable,
        statusFilter,
        refetchData,
        avatarText,
        resolveInvoiceStatusVariantAndIcon,
        resolveClientAvatarVariant,
        sendInvoiceEmail,
        downloadInvoice,
        convertIntoInvoice,
        CSV_invoice_modal,
        showDates,
        startDateModal,
        endDateModal,
        setNullDate,
        typeInvoiceSelected,
        typeExportSelected,
        ability,
        isEditable,
        exportAllChargesCSV,
        exportAllChargesXLS, 
        user,
        formatCurrency,
        exportBilling,
        changeInvoiceModal,
        showChangeInvoiceModal,
        selectedInvoiceSerie,
        selectedCorrectionSerie,
        hideChangeInvoiceModal,
        modalOrConvertInvoice,
        selectedInvoice,
      }
    }
  }



  </script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  </style>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
